import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceTaskEditionNotificationState = createStateReducer(initialState, {
  [events.editTaskSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editTask",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.editTaskFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editTask",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceTaskEditionNotificationState };
